/*
 * use-screen
 */
import { useCallback, useState } from "react"
import { useEventListener } from "./use-event-listener"

export type Screen = {
	height: number
	width: number
	windowHeight: number
	windowWidth: number
	fullscreen: boolean
}

function getScreen() {
	if (typeof window === "undefined") {
		return {
			height: 0,
			width: 0,
			windowHeight: 0,
			windowWidth: 0,
			fullscreen: false,
		}
	}
	return {
		height: window.innerHeight,
		width: window.innerWidth,
		windowHeight: window.outerHeight,
		windowWidth: window.outerWidth,
		fullscreen: window.outerHeight === window.innerHeight,
	}
}

export function useScreen(): Screen {
	const [screen, setScreen] = useState(getScreen())

	const handleResize = useCallback(() => {
		setScreen(getScreen())
	}, [setScreen])

	useEventListener("resize", handleResize)

	return screen
}
